export const MASHINGS_TARGETS = {
  ADDED_MASHINGS: 'addedMashings',
  ADD_MASHING: 'addMashing',
  CURRENT_MASHING: 'currentMashing',
  UPDATE_MASHING: 'updateMashing',
  UPDATED_MASHINGS: 'updatedMashings',
  CREATE_MASH: 'createMash',
  MASHES: 'mashes',
  UPDATE_MASH_BY_ID: 'updateMashById',
  MASH_BY_ID: 'mashById',
  CREATE_PRODUCTION_PROCESS: 'createProductionProcess',
  PRODUCTION_PROCESS_DATA: 'productionProcessData'
};

export const MASHINGS_DEFAULT_STATE = {
  [MASHINGS_TARGETS.ADDED_MASHINGS]: [],
  [MASHINGS_TARGETS.ADD_MASHING]: null,
  [MASHINGS_TARGETS.CURRENT_MASHING]: {},
  [MASHINGS_TARGETS.UPDATE_MASHING]: null,
  [MASHINGS_TARGETS.UPDATED_MASHINGS]: [],
  [MASHINGS_TARGETS.CREATE_MASH]: null,
  [MASHINGS_TARGETS.MASHES]: [],
  [MASHINGS_TARGETS.UPDATE_MASH_BY_ID]: null,
  [MASHINGS_TARGETS.MASH_BY_ID]: null,
  [MASHINGS_TARGETS.CREATE_PRODUCTION_PROCESS]: {},
  [MASHINGS_TARGETS.PRODUCTION_PROCESS_DATA]: {}
};
